//#region src/arrayUtils.ts
function last(array) {
	return array[array.length - 1];
}
function first(array) {
	return array[0];
}
function subtract(array, ...items) {
	if (array.length === 0 || items.length === 0) return [...array];
	const itemsToRemove = /* @__PURE__ */ new Set();
	for (const itemArray of items) for (const item of itemArray) itemsToRemove.add(item);
	return array.filter((item) => !itemsToRemove.has(item));
}
function unique(array) {
	return [...new Set(array)];
}
function uniqueBy(array, key) {
	return [...new Map(array.map((item) => [key(item), item])).values()];
}
function isInArray(item, array) {
	return array.includes(item);
}
function intersection(a, b) {
	return a.filter((value) => b.includes(value));
}
function difference(a, b) {
	return a.filter((value) => !b.includes(value));
}
function isArray(value) {
	return Array.isArray(value);
}
function partition(arr, predicate) {
	const trueArr = [];
	const falseArr = [];
	for (const value of arr) if (predicate(value)) trueArr.push(value);
	else falseArr.push(value);
	return [trueArr, falseArr];
}
function reverse(arr) {
	return [...arr].reverse();
}
function findBy(array, predicate) {
	for (const item of array) if (predicate(item)) return item;
}
function findIndexBy(array, predicate) {
	for (let i = 0; i < array.length; i++) {
		const item = array[i];
		if (item !== void 0 && predicate(item)) return i;
	}
}
async function findIndexByAsync(array, predicate) {
	for (let i = 0; i < array.length; i++) {
		const item = array[i];
		if (item !== void 0 && await predicate(item)) return i;
	}
}

//#endregion
export { difference, findBy, findIndexBy, findIndexByAsync, first, intersection, isArray, isInArray, last, partition, reverse, subtract, unique, uniqueBy };